<template>
  <div class="filter-number">
    <p class="filter-tit">
      {{ fieldname }}
    </p>
    <div class="filter-item">
      <cube-input
        :value="value.min"
        :placeholder="`${minNumPlaceholder}${fieldname}`"
        type="number"
        @change="changeMinHandle"
      />
      <span>~</span>
      <cube-input
        :value="value.max"
        :placeholder="`${maxNumPlaceholder}${fieldname}`"
        type="number"
        @change="changeMaxHandle"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    fieldname () {
      return this.data.fieldname
    },
    maxNumPlaceholder () {
      return this.$t('message["845"]')
    },
    minNumPlaceholder () {
      return this.$t('message["846"]')
    }
  },
  methods: {
    changeMinHandle (e) {
      this.value.min = parseInt(e.target.value)
      this.$emit('change', this.value)
    },
    changeMaxHandle (e) {
      this.value.max = parseInt(e.target.value)
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-number::v-deep {
  .cube-input {
    display: inline-block;
    width: 40%;
    margin: 0 16px;
    .cube-input-field {
      padding: 16px 0;
      line-height: 24px;
      border-color: #dbdbdb;
    }
  }
  span {
    color: #d8d8d8;
  }
}
</style>
